// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1L4mv","title":"AfterFrontImage_title__13w-e"};